import { useAuthStore } from "src/stores/authStore"
import { NamedPath } from "src/util/enums/namedPaths"
import { NavigationGuardWithThis } from "vue-router"

function workspaceRoute() {
  const authStore = useAuthStore()
  // Go to selected workspace only if it exists
  return authStore.selectedWorkspace?.id
    ? { name: NamedPath.WORKSPACE, params: { workspaceId: authStore.selectedWorkspace?.id } }
    : { name: NamedPath.SELECT_WORKSPACE }
}

export const loginGuard: NavigationGuardWithThis<undefined> = (to) => {
  const authStore = useAuthStore()
  return authStore.isLoggedIn ? true : { name: NamedPath.INITIATE_APP, query: to.query }
}

export const loginWorkspaceGuard: NavigationGuardWithThis<undefined> = () => {
  const authStore = useAuthStore()
  return !authStore.isLoggedIn ? true : workspaceRoute()
}

export const lockGuard: NavigationGuardWithThis<undefined> = () => {
  const authStore = useAuthStore()
  return authStore.isLocked ? { name: NamedPath.LOCK } : true
}
